import { get, post, del } from './API';
import downloadPdf from '../Utils/downloadPdf';

const ServiceOfferService = {
  fetchAll: async (params = {}) => {
    // Support pagination, filtering, and search parameters
    // If any params are provided, use the new paginated endpoint
    const hasParams = Object.keys(params).length > 0;
    if (hasParams) {
      return get('/service-offers/offers', params);
    }
    // Legacy behavior - return all offers
    return get('/service-offers/offers');
  },

  fetchById: async (id) => get('/service-offers/offers', { id }),

  createOrUpdate: async (offer) => post('/service-offers/offers', offer),

  duplicate: async (id) => post('/service-offers/offers', {}, {}, { action: 'duplicate', id }),

  delete: async (id) => del('/service-offers/offers', { id }),

  updateStatus: async (id, status) => post('/service-offers/offers', { status }, {}, { action: 'update-status', id }),

  aiExtract: async (text) => post('/service-offers/ai-extract', { text }),

  formatInquiry: async (text) => post('/service-offers/ai-extract', {
    action: 'format-inquiry',
    text,
  }),

  calculateTotal: async (table) => post('/service-offers/ai-extract', {
    action: 'calculate-total',
    table: { columns: table.columns, rows: table.rows },
  }),

  generatePdf: async (offerId) => post('/service-offers/pdf', { offerId }),

  previewPdf: async (offer, language = 'en') => post('/service-offers/pdf', { offer, language }),

  downloadPdf: (pdfData) => downloadPdf(pdfData, 'service-offer.pdf'),

  // Operator Quotes
  fetchOperatorQuotes: async (serviceOfferId) => get('/service-offers/operator-quotes', { serviceOfferId }),

  createOperatorQuote: async (data) => post('/service-offers/operator-quotes', data),

  updateOperatorQuote: async (quoteId, data) => post('/service-offers/operator-quotes', { quoteId, ...data }),

  deleteOperatorQuote: async (id) => del('/service-offers/operator-quotes', { id }),

  sendInquiry: async (serviceOfferId, operatorIds) => post(
    '/service-offers/operator-quotes',
    { serviceOfferId, operatorIds },
    {},
    { action: 'send-inquiry' },
  ),

  applyQuote: async (serviceOfferId, quoteId, markup = 0) => post(
    '/service-offers/operator-quotes',
    { serviceOfferId, quoteId, markup },
    {},
    { action: 'apply-quote' },
  ),

  extractQuoteFromEmail: async (emailText) => post(
    '/service-offers/operator-quotes',
    { emailText },
    {},
    { action: 'extract-quote' },
  ),

  buildInquiryEmail: async (serviceOfferId, operatorName) => post(
    '/service-offers/operator-quotes',
    { serviceOfferId, operatorName },
    {},
    { action: 'build-email' },
  ),

  // Inclusion/Exclusion Templates
  fetchTemplates: async () => get('/service-offers/templates'),
  createOrUpdateTemplate: async (template) => post('/service-offers/templates', template),
  deleteTemplate: async (id) => del('/service-offers/templates', { id }),
};

export default ServiceOfferService;
